// Phase F.2 — Routing rules + resolver API hooks
import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useRoutingRules = (masterId) =>
  useQuery({
    queryKey: ["routing-rules", masterId],
    queryFn: () =>
      axios.get(`${API}/customer-masters/${masterId}/routing-rules`).then((r) => r.data),
    enabled: !!masterId,
  });

export const useCreateRule = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ master_id, ...body }) =>
      axios.post(`${API}/customer-masters/${master_id}/routing-rules`, body).then((r) => r.data),
    onSuccess: (_, vars) =>
      qc.invalidateQueries({ queryKey: ["routing-rules", vars.master_id] }),
  });
};

export const useUpdateRule = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ rule_id, ...body }) =>
      axios.patch(`${API}/customer-masters/routing-rules/${rule_id}`, body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["routing-rules"] }),
  });
};

export const useDeleteRule = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (rule_id) =>
      axios.delete(`${API}/customer-masters/routing-rules/${rule_id}`).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["routing-rules"] }),
  });
};

export const useResolveRouting = () =>
  useMutation({
    mutationFn: (body) =>
      axios.post(`${API}/customer-routing/resolve`, { trace: true, ...body }).then((r) => r.data),
  });
